import { render, staticRenderFns } from "./study-detail.vue?vue&type=template&id=1aeb1b20&scoped=true&"
import script from "./study-detail.vue?vue&type=script&lang=ts&"
export * from "./study-detail.vue?vue&type=script&lang=ts&"
import style0 from "./study-detail.vue?vue&type=style&index=0&id=1aeb1b20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb1b20",
  null
  
)

export default component.exports